import { Component, Injector, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'arbitrage-reason-form',
    templateUrl: './arbitrage-reason-form.component.html',
    styleUrls: ['./arbitrage-reason-form.component.scss'],
    standalone: false
})
export class ArbitrageReasonFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options: FormControlOption[] = [
    {
      value: 'SECURE',
      label: 'Sécuriser',
      suffix: { title: 'A' },
    },
    {
      value: 'REEQUILIBRATE',
      label: 'Rééquilibrer',
      suffix: { title: 'B' },
    },
    { value: 'DYNAMIC', label: 'Dynamiser', suffix: { title: 'C' } },
    { value: 'AUTRE', label: 'Autre', suffix: { title: 'D' } },
  ];
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
    this.products
      ?.get(`${0}`)
      ?.get('parameters')
      ?.get('reason')
      .valueChanges.subscribe(reason => {
        if (reason === 'AUTRE') {
          this.products
            ?.get(`${0}`)
            ?.get('parameters')
            ?.get('reasonComment')
            .setValidators([Validators.required]);
        } else {
          this.products
            ?.get(`${0}`)
            ?.get('parameters')
            ?.get('reasonComment')
            .setValidators([Validators.nullValidator]);
          this.products
            ?.get(`${0}`)
            ?.get('parameters')
            ?.get('reasonComment')
            .setValue(null);
        }
      });
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
